import { FormContainer, LabeledInput, Worksheet } from "uikit"
import React from "react"
import { Dropdown, Input } from "semantic-ui-react"
import { useStore } from "store"
import { AddPersonModal } from "../../../people/AddPersonModal"
import { Footer } from "./Footer"

const SelfEmploymentForm = ({
  data: {
    fields: { description, person_id, amount },
    isModified,
    onSubmit,
    error
  },
  submitLabel = "Done",
  onDelete,
  ownerOptions,
  isNew,
  addNewPerson
}) => {
  return (
    <Worksheet error={error}>
      <Worksheet.Body>
        <Worksheet.Row
          label={"Name of payer or business"}
          paddedField
          description={`A label for this income. It can be the name of your business or something like "Consulting" if you are combining multiple 1099's.`}
        >
          <Worksheet.Field error={description.error}>
            <Input {...description} autoComplete="off" />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row label="Person earning the income" paddedField>
          <Worksheet.Field error={person_id.error}>
            <Dropdown
              {...person_id}
              placeholder="Person"
              options={ownerOptions}
              selection
              data-testid="incomeEarner"
            />
            {person_id.value === "__ADD__" && (
              <AddPersonModal
                submit={personValues =>
                  addNewPerson(personValues).then(({ personId }) =>
                    person_id.onChange(null, { value: personId })
                  )
                }
                onCancel={() => person_id.onChange(null, { value: null })}
              />
            )}
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row
          label="Income amount (pre-tax annual)"
          paddedField
          description="The amount typically earned each year before taxes and deductions"
        >
          <Worksheet.Field error={amount.error}>
            <LabeledInput
              {...amount}
              label=""
              iconText="$"
              iconPosition="left"
              placeholder="0"
            />
          </Worksheet.Field>
        </Worksheet.Row>
      </Worksheet.Body>
      <Footer
        isNew={isNew}
        submitLabel={submitLabel}
        onSubmit={onSubmit}
        onDelete={onDelete}
        isModified={isModified}
        deleteLabel="Delete Income"
        error={error}
      />
    </Worksheet>
  )
}

const SelfEmploymentFormContainer = FormContainer(
  {
    description: {
      type: "string"
    },
    person_id: {
      type: "string"
    },
    amount: {
      type: "unit"
    },
    type: {
      type: "string",
      defaultValue: "selfemployment"
    }
  },
  (fields, ...form) => {}
)(SelfEmploymentForm)

const SelfEmploymentIncome = ({ household, income, ...formProps }) => {
  const [peopleObject] = useStore("householdPeople", household.id)
  const [employersObject, { addPerson }] = useStore(
    "householdEmployers",
    household.id
  )

  const employers = Object.values(employersObject)
  const people = Object.values(peopleObject)
  const isNew = income === null
  const values = isNew
    ? { person_id: people.length === 1 ? people[0].id : null }
    : income
  const employerOptions = employers.map(({ id: value, name: text }) => ({
    value,
    text
  }))
  const canAddEmployer = true
  const ownerOptions = people
    .filter(
      ({ id, role }) =>
        role === "spouse" || role === "client" || id === values.person_id
    )
    .map(({ id: value, first_name: text }) => ({
      value,
      text
    }))

  const canAddOwner = false
  if (canAddOwner) {
    ownerOptions.push({ text: "Add person...", value: "__ADD__" })
  }
  const addNewPerson = values =>
    addPerson({ household_id: household.id, ...values })
  return (
    <SelfEmploymentFormContainer
      {...{
        values,
        employerOptions,
        canAddEmployer,
        ownerOptions,
        addNewPerson,
        ...formProps
      }}
    />
  )
}

export default SelfEmploymentIncome
